
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import NoticeChannel from "@common/src/components/scope/notice-channel/index.vue";
import t from "@common/src/i18n/t";
const inventory = namespace("inventory");
@Component({
  components: {
    NoticeChannel
  }
})
export default class SafetyInventorySet extends Vue {
  @inventory.Action getAlertConfig;
  @inventory.Action saveAlertConfig;
  selectchannel = [];
  returnForm = {
    notifyMethods: [],
    status: "0"
  };
  channel(value, callback) {
    if (!this.returnForm.notifyMethods.length) {
      callback(new Error(t("v210831.please-select-a-path")));
    } else {
      callback();
    }
  }
  wechatCheckedValueArr = (rule, value, callback) => {
    this.channel(value, callback);
  };

  returnFormRule = {
    notifyMethods: [{ required: true, validator: this.wechatCheckedValueArr, trigger: "blur" }],
    status: [{ required: true, message: t("setting.select-whether-enable"), trigger: "blur" }]
  };
  created() {
    this.init();
  }

  init() {
    this.getAlertConfig().then(res => {
      if (res.data) {
        this.selectchannel = res.data.notifyMethods;
        this.returnForm.notifyMethods = res.data.notifyMethods;
        this.returnForm.status = res.data.status;
      }
    });
  }
  submitForm(returnForm) {
    let refForm = this.$refs[returnForm] as any;
    refForm.validate(valid => {
      if (valid) {
        let data = {
          ...this.returnForm
        };
        this.saveAlertConfig(data).then(() => {
          this.$message.success(t("setting.operate-successfully"));
        });
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
}
